export default "__VITE_ASSET__BU2Rw1xz__"